"use client";

import { useState, useEffect } from "react";

interface TypewriterEffectProps {
  text: string;
  className?: string;
  onComplete?: () => void;
}

export default function TypewriterEffect({
  text,
  className,
  onComplete,
}: TypewriterEffectProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isVisible && onComplete) {
      const timer = setTimeout(() => {
        onComplete();
      }, 1000); // Fade in duration
      return () => clearTimeout(timer);
    }
  }, [isVisible, onComplete]);

  return (
    <p
      className={`${className} transition-opacity duration-1000 ease-in-out ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      {text}
    </p>
  );
}